import General from '../utils/GeneralUtils';
import './UniversalTag.scss';

export default function UniversalTag({ category = 'unknown', classOverride = '', onClick, tooltipContent, context }: { category?: string; classOverride?: string; onClick?: () => void; tooltipContent?: string; context?: string }) {

  if (!category) return null

  if (typeof category === 'number') {
    category = String(category);
  }

  const categoryMap: any = {
    'SCHOOL': 'School',
    'DISTRICT': 'District',
    'AGENCY': 'Agency',
    'PUBLIC': 'Public',
    'PRIVATE': 'Private',
    'UNKNOWN': 'Unknown',
    'MANAGER': 'Manager',
    'TEACHER': 'Teacher',
    'OTHER': 'Other',
    'THRILLSHARE': 'Thrillshare',
    'FINALSITE': 'Finalsite',
    'EDLIO': 'Edlio',
    'WIX': 'Wix',
    'PARENT': 'Parent',
    'CHILD': 'Child',
    'STAFF_DIRECTORY': 'Staff Directory',
    'MAIN_WEBSITE': 'Main Website',
    'STAFF_SUPERINTENDENT': 'Superintendent Page',
    'STAFF_PRINCIPAL': 'Principal Page',
    'STAFF_PRINCIPAL_ASSISTANT': 'Assistant Principal Page',
    'STAFF_LEADERSHIP': 'Leadership Page',
    'STAFF_ADMINISTRATION': 'Administration Page',
    'STAFF_PROFILE': 'Staff Profile',
    'WEBSITE': 'Website',
    'BOARD_MEETING': 'Board Meeting',
    'CURRICULUM': 'Curriculum',
    'HIRE_ANNOUNCEMENT': 'Hire Announcement',
    'MEMBER_DISTRICTS': 'Member Districts',
    'SOCIAL_STUDIES': 'Social Studies',
    'STRATEGIC_PLAN': 'Strategic Plan',
    'BOT': 'Bot',
    'HUMAN': 'Human',
    'PARSER': 'Parser',
    'SUB': 'Subdomain',
    'SIBLING': 'Sibling',
    'NOTCHR': 'Regular District',
    'CHRTIDEAESEA': 'Charter District',
    'CHRTNOTLEA': 'Charter District',
    'CHRTIDEA': 'Charter District',
    'CHRTESEA': 'Charter District',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'PENDING_UPLOAD': 'Pending Upload',
    'VERIFIED': 'Verified',
    'UNVERIFIED': 'Unverified',
    'NOT_VERIFIED': 'Not Verified',
    'CANCELLED': 'Cancelled',
    'FAILED': 'Failed',
    'FAILURE': 'Failure',
    'IN_PROGRESS': 'In Progress',
    'NOT_STARTED': 'Not Started',
    'RUNNING': 'Running',
    'SUCCEEDED': 'Succeeded',
    'PARTIALLY_SUCCEEDED': 'Partially Succeeded',
    'TIMED_OUT': 'Timed Out',
    'NO_CONTACTS_FOUND': 'No Contacts Found',
    'DISTRICT_VERIFIED': 'District Verified',
    'EDUCATOR': 'Educator',
    'SCHOOL_LEADER': 'School Leader',
    'DISTRICT_LEADER': 'District Leader',
    'TECH_INFLUENCER': 'Tech Influencer',
    'INSTRUCTIONAL_LEADER': 'Instructional Leader',
    'COMPLIANCE_OFFICER': 'Compliance Officer',
    'STAFF': 'Staff',
    'SUPPORT_STAFF': 'Support Staff',
    'ADMINISTRATIVE_STAFF': 'Administrative Staff',
    'SPECIAL_PROGRAMS': 'Special Programs',
    'COMMUNICATIONS_LEADER': 'Communications Leader',
    'OPERATIONS_MANAGER': 'Operations Manager',
    'HEALTH_WELLNESS': 'Health & Wellness',
    'BOARD_MEMBER': 'Board Member',
    'SUCCESS': 'Success',
    'PARTIAL_SUCCESS': 'Partial Success',
    'ASSOCIATED': 'Associated',
    'NOT_ASSOCIATED': 'Not Associated',
    'CREATED': 'Created',
    'UPDATED': 'Updated',
    'DELETED': 'Deleted',
    'SKIPPED': 'Skipped',
    'CONFLICT': 'Conflict',
    'ERROR': 'Error',
    'WARNING': 'Warning',
    'STRONG': 'Strong',
    'WEAK': 'Weak',
    'VERY_WEAK': 'Very Weak',
    'VERY_STRONG': 'Very Strong',
    'MODERATE': 'Moderate',
    'DETECTED': 'Detected',
    'LLM_ANALYZING': 'LLM Analyzing',
    'HUMAN_ANALYZING': 'Human Analyzing',
    'REJECTED': 'Rejected',
    'APPROVED': 'Approved',
    // Canonical contact statuses
    'ACCEPTED': 'Accepted',
    'STAGED': 'Staged',
    'ARCHIVED': 'Archived',
    // Keystone - Entity types
    'CANONICAL_CONTACT': 'Canonical Contact',
    // Keystone - Derived event tiers
    'EVIDENCE_OBSERVED': 'Evidence Observed',
    'FIELD': 'Field',
    'SUMMARY': 'Summary',
    // Keystone - Eligibility statuses
    'ELIGIBLE': 'Eligible',
    'PENDING_DECISION': 'Pending Decision',
    'PENDING_PROCESSING': 'Pending Processing',
    // Keystone - Derived event actions
    'PROCESSED_CREATED': 'Processed Created',
    'PROCESSED_LINKED': 'Processed Linked',
    'PROCESSED_REJECTED': 'Processed Rejected',
    // Keystone - Observation types
    'PRESENT': 'Present',
    'DEPARTED': 'Departed',
    // Keystone - Observation resolution methods
    'EMAIL_DOMAIN': 'Email Domain',
    'URL_DOMAIN': 'URL Domain',
    'URL_PREFIX': 'URL Prefix',
    'FREEFORM_NAME': 'Freeform Name',
    // Keystone - Contact decision types
    'DISTRICT_CONFLICT': 'District Conflict',
    'NAME_NO_MATCH': 'Name No Match',
    'SCHOOL_CONFLICT': 'School Conflict',
    'SCHOOL_DISTRICT_MISMATCH': 'School District Mismatch',
    'TITLE_NOT_CLASSIFIED': 'Title Not Classified',
    'DUPLICATE': 'Duplicate',
    'OWNER': 'Owner',
    'MEMBER': 'Member',
    'ME': 'Me',
    'decision maker': 'Decision Maker',
    'educator': 'Educator',
    'CSV': 'CSV',
    'JSON': 'JSON',
    'HUBSPOT': 'HubSpot',
    'SALESFORCE': 'Salesforce',
    'INSTITUTION': 'Institution',
    'CONTACT': 'Contact',
    'CONTACT_INSTITUTION_ASSOCIATION': 'Association',
    'INGESTION': 'Website Tracking',
    'TARGET_SELECTION': 'Target Selection',
    'FIELDS_SELECTION': 'Fields Selection',
    'OPTIONS_SELECTION': 'Options Selection',
    'REVIEW': 'Review',
    'EXPORT_PROGRESS': 'Export Progress',
    'REVIEW_PROGRESS': 'Review Progress',
    'REGULAR': 'Regular',
    'CHARTER': 'Charter',
    'SPECIALIZED': 'Specialized',
    'TITLE_I': 'Title I',
    'SERVICE': 'Service',
    'SUPERVISORY': 'Supervisory',
    'STATE': 'State',
    'COMPONENT': 'Component',
    'FEDERAL': 'Federal',
    'DONE': 'Done',
    'UNREACHABLE': 'Unreachable',
    'SUBMITTED': 'Submitted',
    'ALTERNATIVE': 'Alternative',
    'VOCATIONAL': 'Vocational',
    'SELPA': 'SELPA',
    'SPED': 'SPED',
    'UNION': 'Union',
    'PARENT_ORG': 'Parent Org',
    'CONSORTIUM': 'Consortium',
    'TITLE': 'Title',
    'INACTIVE': 'Inactive',
    'closedwon': 'Closed Won',
    'free-email': 'Free Email',
    'LLM': 'LLM',
    'PARSING': 'Parsing',
    'ACTIVE': 'Active',
    'ENABLED': 'Enabled',
    'DISABLED': 'Disabled',
    'DEAL_LOST': 'Deal Lost',
    'DEAL_WON': 'Deal Won',
    'EMAIL': 'Email',
    'NAME_DISTRICT': 'Name + District',
    'NAME_SCHOOL': 'Name + School',
    'NOT_FOUND': 'Not Found',
    'FOUND': 'Found',
    'CRM': 'HubSpot',
    'CRM_UNASSOCIATED': 'HubSpot (unassociated)',
    'EDULEAD': 'Edulead',
    'IN_BOTH': 'Company association exists in both places',
    'ONLY_HUBSPOT': 'Company association exists only in HubSpot, we recommend disassociating',
    'ONLY_EDULEAD': 'Company association exists only in Edulead, we recommend associating',
    'CREATE_COMPANY': 'Create Company',
    'ASSOCIATE': 'Associate',
    'DISASSOCIATE': 'Disassociate',
    'DO_NOTHING': 'Do Nothing',
    'FETCHING_FROM_CRM': 'Fetching from CRM',
    'FETCHING': 'Fetching',
    'MATCHING': 'Matching',
    'PREVIEWING': 'Previewing',
    'APPLYING': 'Applying',
    'REVIEWING': 'Reviewing',
    'CONFIRMING_ACTIONS': 'Confirming Actions',
    'UPDATING': 'Updating',
    'NAME_ADDRESS': 'Name + Address',
    'NCES_ID': 'NCES ID',
    // Matched through alt_nces_ids, i.e. the customer holds a merged or retired identifier.
    'NCES_ALT': 'NCES ID (retired)',
    'MATCHED': 'Matched',
    'NO_MATCH': 'No match',
    // Terminal state of a match run: the scan finished and the results are reviewable.
    'READY': 'Ready for review',
    'NCES_IDS': 'NCES IDs',
    'DISTRICT_NCES_ID': 'District NCES ID',
    'SCHOOL_NCES_ID': 'School NCES ID',
    'ENROLLMENT': 'Enrollment',
    'LOCATION': 'Location',
    'ADDRESS': 'Address',
    'INSTITUTION_URL_SEARCH': 'Institution URL Search',
    'URL_ALREADY_EXISTS': 'URL Already Exists',
    'URL_CREATED': 'URL Created',
    'URL_NOT_FOUND': 'URL Not Found',
    'URL_VERSION': 'URL Version',
    'BAD_DOMAIN': 'Bad Domain',
    'BERT': 'BERT',
    'SUBSTRING': 'Substring',
    'EXACT': 'Exact',
    'USER': 'User',
    'DOMAIN': 'Domain',
    'PREFIX': 'Prefix',
    'HOMEPAGE': 'Homepage',
    'CONTACT_US': 'Contact Us',
    'ANCHOR_CONTAINS': 'Anchor Contains',
    'URL_CONTAINS': 'URL Contains',
    'URL_ENDS_WITH': 'URL Ends With',
    'RECENT': 'Recent',
    'STALE': 'Stale',
    'OLD': 'Old',
    'CRAWLER': 'Crawler',
    'FOIA_ARTIFACT': 'FOIA Artifact',
    'URL': 'URL',
    'FOIA': 'FOIA',
    'ANCHOR_TEXT': 'Anchor Text',
    'CRAWLING_JOB': 'Crawling Job',
    'CONTACT_RECORD_BIO': 'Bio',
    'DECISION': 'Decision',
    'BOARD_MEETINGS': 'Board Meetings',
    'GET_STAFF': 'Get Staff',
    'DIRECT_LINE': 'Direct Line',
    'NEW': 'New',
    'TAKE': 'Take',
    'SKIP': 'Skip',
    'INELIGIBLE': "Can't Export",
    'INELIGIBLE_ASSOCIATION': "Can't Export Company Association",
    'ALREADY_ASSOCIATED': 'Already Associated',
    'NOT_LINKED': 'Not Linked',
    'NA': 'N/A',
    'CREATE': 'Create',
    'UPDATE': 'Update',
    'REMOVE': 'Remove',
    // Operation + record type combinations for export review
    'CREATE_CONTACT': 'Create Contact',
    'UPDATE_CONTACT': 'Update Contact',
    'CREATE_ASSOCIATION': 'Create Association',
    'REMOVE_ASSOCIATION': 'Remove Association',
    // Email validation statuses (lowercase - legacy)
    'valid': 'Valid',
    'invalid': 'Invalid',
    'catch-all': 'Catch-All',
    'unknown': 'Unknown',
    'spamtrap': 'Spam Trap',
    'abuse': 'Abuse',
    'do_not_mail': 'Do Not Mail',
    // Email validation statuses (uppercase - normalized)
    'VALID': 'Valid',
    'INVALID': 'Invalid',
    'CATCH_ALL': 'Catch-All',
    'SPAMTRAP': 'Spam Trap',
    'ABUSE': 'Abuse',
    'DO_NOT_MAIL': 'Do Not Mail',
    'DISPOSABLE': 'Disposable',
    // Email guess outcomes - why a guess was skipped, and whether it reached the contact
    'SKIPPED_AMBIGUOUS': 'Ambiguous',
    'SKIPPED_BAD_NAME': 'Bad Name',
    'SKIPPED_ROLE_INBOX': 'Role Inbox',
    'COLLISION': 'Collision',
    'PROMOTED': 'Promoted',
    'SUPERSEDED': 'Superseded',
    // URL change log field names (lowercase to match database values)
    'type': 'type',
    'subtype': 'subtype',
    'status': 'status',
    'type_match': 'type_match',
    'year': 'year',
    'true': 'true',
    'false': 'false',
    // DataGuard - Ticket statuses
    'OPEN': 'Open',
    'RESOLVED': 'Resolved',
    'WONT_FIX': "Won't Fix",
    'FALSE_POSITIVE': 'False Positive',
    // DataGuard - Severities
    'CRITICAL': 'Critical',
    'HIGH': 'High',
    'MEDIUM': 'Medium',
    'LOW': 'Low',
    // DataGuard - Guard categories
    'DOMAIN_INTEGRITY': 'Domain Integrity',
    'INSTITUTION_INTEGRITY': 'Institution Integrity',
    'URL_INTEGRITY': 'URL Integrity',
    'URL_PREFIX_INTEGRITY': 'URL Prefix Integrity',
    'URL_SEGMENTS': 'URL Segments',
    'SCHOOL_DISCOVERY_URL_PREFIX': 'School Discovery URL Prefix',
    'CONTACT_INTEGRITY': 'Contact Integrity',
    'CROSS_ENTITY': 'Cross Entity',
    // DataGuard - Triggered by
    'MANUAL': 'Manual',
    'SCHEDULE': 'Schedule',
    // Keystone Events - Sources
    'DB_TRIGGER': 'DB Trigger',
    'APPLICATION': 'Application',
    // Keystone Events - Types
    'CONTACT_CREATED': 'Contact Created',
    'DOMAIN_UPDATED': 'Domain Updated',
    'URL_UPDATED': 'URL Updated',
    'CONTACT_RECORD_CREATED': 'Contact Record Created',
    'DOMAIN_CREATED': 'Domain Created',
    'URL_PREFIX_CREATED': 'URL Prefix Created',
    // Keystone Events - Entity Types
    'DOCUMENT': 'Document',
    'INSTITUTION_URL_PREFIX': 'URL Prefix',
    'CONTACT_RECORD': 'Contact Record',
    // DataGuard - Resolution strategies
    'AUTO_IMMEDIATE': 'Auto Immediate',
    'AUTO_DEFERRED': 'Auto Deferred',
    // Export associations - Primary/Indirect
    'PRIMARY': 'Primary',
    'INDIRECT': 'Indirect',
    // Field status
    'REQUIRED': 'Required',
    // Service limit sources
    'DEFAULT': 'Default',
    'OVERRIDE': 'Override',
    // Email verification
    'EMAIL_VERIFICATION': 'Email Verification',
    'EMAIL_GUESS': 'Email Guess',
    'EMAIL_GUESS_PROMOTED': 'Guess Promoted',
    'SHARED_INBOX': 'Shared Inbox',
    // Field changes
    'FIELD_CHANGED': 'Field Changed',
    // Derived event actions
    'DETAIL': 'Detail',
    'STRICT': 'Strict',
    // Employment status
    'INTERIM': 'Interim',
    // Keystone - NC to CC linking
    'NC_CC_LINKED': 'Normalized Contact Linked to Canonical Contact',
    // Email source types
    'OBSERVED': 'Observed',
    'GENERATED': 'Generated',
    'CURRENT': 'Current',
    // Contact decisions - duplicate detection
    'DUPLICATE_UNIQUE_ROLE': 'Duplicate Unique Role',
    // Email types
    'PERSONAL': 'Personal',
    'ROLE': 'Role',
    // Phone uniqueness statuses
    'UNIQUE': 'Unique',
    'SHARED_CONTACT': 'Shared',
    'SHARED_INSTITUTION': 'Shared',
    'SHARED_CONTACT_INSTITUTION': 'Shared',
    // Workflow steps - base strategies
    'RULE': 'Rule',
    'AI': 'AI',
    // HUMAN already defined above
    // Workflow steps - completed
    'RULE_COMPLETED': 'Rule',
    'AI_COMPLETED': 'AI',
    'HUMAN_COMPLETED': 'Human',
    // Workflow steps - current
    'RULE_CURRENT': 'Rule ⏸',
    'AI_CURRENT': 'AI ⏸',
    'HUMAN_CURRENT': 'Human ⏸',
    // Workflow steps - failed
    'RULE_FAILED': 'Rule ✗',
    'AI_FAILED': 'AI ✗',
    'HUMAN_FAILED': 'Human ✗',
    // No implementation
    'NO_IMPLEMENTATION': 'No Implementation',
    // API usage source
    'UI': 'UI',
    'API': 'API',
    // Keystone Events - Processing statuses
    'PROCESSED': 'Processed',
    // Cognito user statuses
    'CONFIRMED': 'Confirmed',
    'UNCONFIRMED': 'Unconfirmed',
    'FORCE_CHANGE_PASSWORD': 'Force Change Password',
    'RESET_REQUIRED': 'Reset Required',
    'COMPROMISED': 'Compromised',
    'EXTERNAL_PROVIDER': 'External Provider',
  }
  /**
   * What a tag value means, shown on hover. Falls back to the tooltipContent prop, so a caller
   * can still say something more specific about one instance.
   *
   * Some values mean different things in different columns - VALID and INVALID are ZeroBounce
   * results on an address and TitleValidationStatus values on a title, and UNKNOWN is also an
   * institution type. Those are keyed "context:VALUE" and only resolve when the caller passes a
   * matching context, so a tag can never explain itself as the wrong thing. Values that mean one
   * thing everywhere are keyed bare and need no context.
   */
  const descriptionMap: Record<string, string> = {
    // Ambiguous across columns - only shown when the caller names the context
    'email:VALID': 'The provider confirmed this mailbox exists and accepts mail.',
    'email:INVALID': 'The provider confirmed this mailbox does not exist. Mailing it would bounce.',
    'email:UNKNOWN': 'The provider could not reach the mail server to check, so the address is unproven either way.',
    'title:VALID': 'The title was recognised and normalized successfully.',
    'title:INVALID': 'The title could not be used - non-latin characters, a forbidden phrase, or too short or long.',
    'institution:UNKNOWN': 'The institution type could not be determined from the available evidence.',
    // Email guess outcomes
    'SKIPPED_AMBIGUOUS': 'No guess was made: the pattern points at more than one person at this institution, such as a John and a Jane Smith both mapping to jsmith@.',
    'SKIPPED_BAD_NAME': 'No guess was made: the name could not produce an address, being too short, non-latin, or a placeholder.',
    'SKIPPED_ROLE_INBOX': 'No guess was made: the address the pattern produced is a shared mailbox, not a person.',
    'COLLISION': 'The generated address is already held by another contact, so it was not used - an address identifies one person or nobody.',
    'PROMOTED': 'The address was verified and written onto the contact. It is marked as generated, not observed.',
    'SUPERSEDED': 'A real observed address arrived for this contact, so the guess was set aside in its favour.',
    // ZeroBounce verification results
    'CATCH_ALL': 'The domain accepts mail for any address, so the provider cannot confirm this particular mailbox exists.',
    'SPAMTRAP': 'The address is a known spam trap. Mailing it damages sending reputation.',
    'ABUSE': 'The address belongs to someone who has previously reported mail as spam.',
    'DO_NOT_MAIL': 'The provider flagged this as an address that should not be mailed, such as a complainer or a role account.',
    'DISPOSABLE': 'A temporary throwaway address that will stop working.',
  };

  const label = categoryMap[category]
  // Context wins when given, so email:VALID never shows on a title tag; a bare key covers values
  // that mean the same thing wherever they appear.
  const description =
    tooltipContent ?? (context ? descriptionMap[`${context}:${category}`] : undefined) ?? descriptionMap[category]
  const specificClass = `universal-tag-${General.replaceNonAlphanumericWithDash(category)}`;
  // Only add fallback class if category is not in the map (unknown category)
  const classNames = classOverride || (label ? specificClass : `universal-tag-fallback ${specificClass}`);

  return <>
    {
      category !== 'unknown' &&
      <span
        className={`universal-tag ${classNames} ${onClick ? 'universal-tag--clickable' : ''}`}
        onClick={onClick}
        data-tooltip-id={description ? 'main-tooltip' : undefined}
        data-tooltip-content={description}
        style={description ? { cursor: 'help' } : undefined}
      >
        { label || General.capitalizeAllWords(category) }
      </span>
    }
  </>
}
